import request from '@/utils/request'

// 查询参数列表
export function getUserCasePageList(query) {
  return request({
    url: '/mini/content/case/getUserCasePageList',
    method: 'post',
    data: query
  })
}

export function getCaseDetail(caseId) {
  return request({
    url: `/mini/content/case/${caseId}`,
    method: 'get'
  })
}

